import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label } from "reactstrap";
import { formatValue } from "services/globals";
import { useSimuladorContext } from "../../../contexts/SimuladorContext";
const md5 = require("md5");
import { decode as base64_decode } from "base-64";
import { getValorDescarga } from "services/utils";
import { useProductContext } from "contexts/ProdutosSimuladorContext";
import TipoFaturamento from "../Components/TipoFaturamento";
import TipoLogistica from "../Components/TipoLogistica";
import TipoEntrega from "../Components/TipoEntrega";
import { enterpriseUseDelivery } from "services/utils";

function SimuladorCabCompleto(props) {
  const setorUsuario = base64_decode(sessionStorage.getItem(md5("NUSETOR")));

  const { dataSimulador, setDataSimulador, setCompanyHasChanged } =
    useSimuladorContext();

  const {
    setDataProducts,
    dataProducts,
    triggerFastSubmitFromHeader,
    setFastSubmitLoading,
  } = useProductContext();

  const getSessionKey = (suffix) =>
    `SIMULADOR_${suffix}_${props.getCabNuSim || "0"}`;

  const [pPalha, setPPalha] = useState(
    () => sessionStorage.getItem(getSessionKey("P_PALHA")) || ""
  );
  const [pMix, setPMix] = useState(
    () => sessionStorage.getItem(getSessionKey("P_MIX")) || ""
  );
  const [pKro, setPKro] = useState(
    () => sessionStorage.getItem(getSessionKey("P_KRO")) || ""
  );

  useEffect(() => {
    setPPalha(sessionStorage.getItem(getSessionKey("P_PALHA")) || "");
    setPMix(sessionStorage.getItem(getSessionKey("P_MIX")) || "");
    setPKro(sessionStorage.getItem(getSessionKey("P_KRO")) || "");
    setDataSimulador((prev) => ({
      ...prev,
      P_PALHA: sessionStorage.getItem(getSessionKey("P_PALHA")) || "",
      P_MIX: sessionStorage.getItem(getSessionKey("P_MIX")) || "",
      P_KRO: sessionStorage.getItem(getSessionKey("P_KRO")) || "",
    }));
  }, [props.getCabNuSim]);

  const handlePPalhaBlur = () => {
    console.log("[BLUR P_PALHA] valor digitado:", pPalha);
    if (pPalha === dataSimulador?.P_PALHA) {
      console.log("[BLUR P_PALHA] valor igual ao atual, ignorando");
      return;
    }
    sessionStorage.setItem(getSessionKey("P_PALHA"), pPalha);
    setDataSimulador((prev) => ({ ...prev, P_PALHA: pPalha }));
    if (!pPalha || Number(pPalha) <= 0) {
      console.log("[BLUR P_PALHA] valor zero ou em branco, itens não serão alterados");
      return;
    }
    const hasDifferentCommission =
      Number(pPalha) > 0 &&
      Number(pPalha) <= 6 &&
      dataProducts.some(
        (product) =>
          product.PALHA_MIX === "P" &&
          Number(product.PERCRCA) !== Number(pPalha)
      );
    if (!hasDifferentCommission) return;
    triggerFastSubmitFromHeader();
    setFastSubmitLoading(true);
    setDataProducts((prevProducts) => {
      const updated = prevProducts.map((product) =>
        product.PALHA_MIX === "P"
          ? {
              ...product,
              PERCRCA: Number(pPalha),
              FLG_PERCRCA_MANUAL: "S",
              updated: true,
            }
          : product
      );
      const matches = updated.filter((p) => p.PALHA_MIX === "P");
      console.log("[BLUR P_PALHA] produtos atualizados:", {
        value: pPalha,
        total: updated.length,
        matches: matches.length,
        sample: matches[0],
      });
      return updated;
    });
  };

  const handlePMixBlur = () => {
    console.log("[BLUR P_MIX] valor digitado:", pMix);
    if (pMix === dataSimulador?.P_MIX) {
      console.log("[BLUR P_MIX] valor igual ao atual, ignorando");
      return;
    }
    sessionStorage.setItem(getSessionKey("P_MIX"), pMix);
    setDataSimulador((prev) => ({ ...prev, P_MIX: pMix }));
    if (!pMix || Number(pMix) <= 0) {
      console.log("[BLUR P_MIX] valor zero ou em branco, itens não serão alterados");
      return;
    }
    const hasDifferentCommission =
      Number(pMix) > 0 &&
      Number(pMix) <= 6 &&
      dataProducts.some(
        (product) =>
          product.PALHA_MIX === "M" &&
          Number(product.PERCRCA) !== Number(pMix)
      );
    if (!hasDifferentCommission) return;
    triggerFastSubmitFromHeader();
    setFastSubmitLoading(true);
    setDataProducts((prevProducts) => {
      const updated = prevProducts.map((product) =>
        product.PALHA_MIX === "M"
          ? {
              ...product,
              PERCRCA: Number(pMix),
              FLG_PERCRCA_MANUAL: "S",
              updated: true,
            }
          : product
      );
      const matches = updated.filter((p) => p.PALHA_MIX === "M");
      console.log("[BLUR P_MIX] produtos atualizados:", {
        value: pMix,
        total: updated.length,
        matches: matches.length,
        sample: matches[0],
      });
      return updated;
    });
  };

  const handlePKroBlur = () => {
    console.log("[BLUR P_KRO] valor digitado:", pKro);
    if (pKro === dataSimulador?.P_KRO) {
      console.log("[BLUR P_KRO] valor igual ao atual, ignorando");
      return;
    }
    sessionStorage.setItem(getSessionKey("P_KRO"), pKro);
    setDataSimulador((prev) => ({ ...prev, P_KRO: pKro }));
    if (!pKro || Number(pKro) <= 0) {
      console.log("[BLUR P_KRO] valor zero ou em branco, itens não serão alterados");
      return;
    }
    const hasDifferentCommission =
      Number(pKro) > 0 &&
      Number(pKro) <= 6 &&
      dataProducts.some(
        (product) =>
          product.PALHA_MIX === "K" &&
          Number(product.PERCRCA) !== Number(pKro)
      );
    if (!hasDifferentCommission) return;
    triggerFastSubmitFromHeader();
    setFastSubmitLoading(true);
    setDataProducts((prevProducts) => {
      const updated = prevProducts.map((product) =>
        product.PALHA_MIX === "K"
          ? {
              ...product,
              PERCRCA: Number(pKro),
              FLG_PERCRCA_MANUAL: "S",
              updated: true,
            }
          : product
      );
      const matches = updated.filter((p) => p.PALHA_MIX === "K");
      console.log("[BLUR P_KRO] produtos atualizados:", {
        value: pKro,
        total: updated.length,
        matches: matches.length,
        sample: matches[0],
      });
      return updated;
    });
  };

  const handleCabVlrDegustacao = (value) => {
    setDataSimulador({ ...dataSimulador, DEGUSTACAO: value });
    setCabVlrDegustacao(value);
  };

  const handleCabVlrDescarga = (value) => {
    setDataSimulador({ ...dataSimulador, DESCARGA: value });
    setCabVlrDescarga(value);
  };

  const handleChangeEmpresa = (index) => {
    setCompanyHasChanged(true);
    const CODEMP = index != "" ? props.getCabOptionEmpresa[index].CODEMP : "";
    const NOMEFANTASIA =
      index != "" ? props.getCabOptionEmpresa[index].NOMEFANTASIA : "";
    props.setCabEmpresa({
      codEmp: NOMEFANTASIA,
      nomeFantasia: NOMEFANTASIA,
    });

    let regraEntrega;

    if (enterpriseUseDelivery(CODEMP)) {
      regraEntrega = { PERLOGISTICA: null, VLRFRETELOG: null };
    } else {
      regraEntrega = { VLR_ENTREGA: null, PER_ENTREGA: null };
    }

    setDataSimulador({
      ...dataSimulador,
      ...regraEntrega,
      CODEMP,
      comLogistita: false,
      NOMEFANTASIA,
    });

    const newProducts = dataProducts?.map((product) => {
      return { ...product, updated: true };
    });
    if (newProducts?.length > 0) setDataProducts(newProducts);
  };

  const handleChangeTipoPagDescarga = (index) => {
    let TIPOPAGDESCARGA =
      index != "" ? props.getCabOptionTipoPagDescarga[index].VALOR : "";
    props.setCabTipoPagDescarga(TIPOPAGDESCARGA);

    setDataSimulador({ ...dataSimulador, TIPOPAGDESCARGA });
  };

  const {
    setCabVlrDegustacao,
    setCabVlrDescarga,
    //gets
    getCabOptionEmpresa,
    getCabEmpresa,
    getCabImcGeral,
    getCabCliente,
    getCabVlrDegustacao,
    getCabOptionTipoPagDescarga,
    getCabTipoPagDescarga,
    getCabVlrDescarga,
    getCabStatusSimulacao,
  } = props;

  useEffect(() => {
    let QTD_PALET = 0;
    if (getCabCliente?.AD_DESPALET == "S") {
      QTD_PALET = dataProducts.reduce((acc, current) => {
        return acc + Math.round(current?.QTDNEG / current?.QTDEPALET, -1);
      }, 0);
    }

    let QTD_NEG = 0;
    QTD_NEG = dataProducts.reduce((acc, current) => {
      return acc + Number(current?.QTDNEG);
    }, 0);

    if (QTD_NEG > 0) {
      const valorDescarga = getValorDescarga({
        ...getCabCliente,
        QTD_NEG,
        QTD_PALET,
      });

      // if (getCabVlrDescarga != valorDescarga) {
      //   // setCabVlrDescarga(valorDescarga); // comentado porque os dados nao estao mais cadastrados, tem que ver direito essa rotina, talvez nem tenha que ter isso
      //   setDataSimulador((state) => ({
      //     ...state,
      //     DESCARGA: valorDescarga,
      //   }));
      // }
    }

 
  }, [props]);

  return (
    <>
      <Col style={{ padding: "5px 5px" }}>
        <Row>
          <Col md={6}>
            <Label for="cliente">Cod / Razão Social</Label>
            <Input
              id="cliente"
              value={`${getCabCliente?.CODPARC} - ${getCabCliente?.RAZAO}`}
              disabled
            />
          </Col>
          <Col md={6}>
            <Label for="nome_fantasia">Nome Fantasia</Label>
            <Input
              id="nome_fantasia"
              value={`${getCabCliente?.FANTASIA}`}
              disabled
            />
          </Col>
          <Col md={3}>
            <Label for="inputEmpresaFaturante">Empresa Faturante</Label>
            <Input
              type="select"
              id="inputEmpresaFaturante"
              name="inputEmpresaFaturante"
              onChange={(e) => handleChangeEmpresa(e.target.value)}
              style={{ cursor: "pointer" }}
              disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
              required
            >
              <option value="">{"< Selecione uma empresa >"}</option>
              {getCabOptionEmpresa?.map((emp, index) => {
                return (
                  <option
                    key={index}
                    value={index}
                    selected={
                      getCabEmpresa?.codEmp == emp.CODEMP ? true : false
                    }
                  >
                    {emp.CODEMP + " - " + emp.NOMEFANTASIA}
                  </option>
                );
              })}
            </Input>
            <Label for="vlrDegustacao">R$ Degustação</Label>
            <Input
              type="number"
              id="vlrDegustacao"
              name="vlrDegustacao"
              value={getCabVlrDegustacao}
              min={0}
              onChange={(e) => handleCabVlrDegustacao(e.target.value)}
              disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
            />
          </Col>
          {!enterpriseUseDelivery(dataSimulador.CODEMP) && (
            <Col md={3}>
              <TipoFaturamento />
              <TipoLogistica />
            </Col>
          )}
          {enterpriseUseDelivery(dataSimulador.CODEMP) && (
            <Col md={3}>
              <TipoEntrega />
            </Col>
          )}
          <Col md={3}>
            <Label for="tipoPagDescarga">Tipo Descarga</Label>
            <Input
              type="select"
              id="tipoPagDescarga"
              name="tipoPagDescarga"
              onChange={(e) => handleChangeTipoPagDescarga(e.target.value)}
              style={{ cursor: "pointer" }}
              disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
              required
            >
              <option value="">{"< Selecione Tipo de Descarga >"}</option>
              {getCabOptionTipoPagDescarga?.map((descarga, index) => {
                return (
                  <option
                    key={index}
                    value={index}
                    selected={getCabTipoPagDescarga == descarga.VALOR}
                  >
                    {descarga.OPCAO}
                  </option>
                );
              })}
            </Input>
            <Label for="vlrDescarga">R$ Descarga</Label>
            <Input
              type="number"
              id="vlrDescarga"
              name="vlrDescarga"
              value={getCabVlrDescarga}
              min={0}
              disabled={
                getCabStatusSimulacao != 0 || setorUsuario == "1"
                // &&                descargaEnable
              }
              onChange={(e) => handleCabVlrDescarga(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Label for="imcGeral">%IMC Geral</Label>
            <Input
              id="imcGeral"
              value={formatValue("decimal", dataSimulador?.IMC_CLI)}
              disabled
            />
            <div style={{ display: "flex", gap: "10px" }}>
              <div>
                <Label for="p.palha">% Palha</Label>
                <Input
                  type="number"
                  id="p.palha"
                  value={pPalha}
                  min={0}
                  onChange={(e) => {
                    console.log("[CHANGE P_PALHA]", e.target.value);
                    setPPalha(e.target.value);
                  }}
                  onBlur={handlePPalhaBlur}
                  disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
                />
              </div>
              <div>
                <Label for="p.mix">% Mix</Label>
                <Input
                  type="number"
                  id="p.mix"
                  value={pMix}
                  min={0}
                  onChange={(e) => {
                    console.log("[CHANGE P_MIX]", e.target.value);
                    setPMix(e.target.value);
                  }}
                  onBlur={handlePMixBlur}
                  disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
                />
              </div>
              <div>
                <Label for="p.kro">% Kro</Label>
                <Input
                  type="number"
                  id="p.kro"
                  value={pKro}
                  min={0}
                  onChange={(e) => {
                    console.log("[CHANGE P_KRO]", e.target.value);
                    setPKro(e.target.value);
                  }}
                  onBlur={handlePKroBlur}
                  disabled={getCabStatusSimulacao != 0 || setorUsuario == "1"}
                />
              </div>
            </div>

          </Col>
        </Row>
      </Col>
    </>
  );
}

export default SimuladorCabCompleto;
